export default __webpack_public_path__ + "static/media/ic_bsc_16.d4d0ece2.svg";